import { deleteCookie } from "@/utils/cookies";
import logToSentry from "@/utils/logToSentry";

function getKlaviyo(): KlaviyoObject | null {
  if (typeof window === "undefined") return null;
  return window.klaviyo ?? null;
}

export function identifyKlaviyoProfile(
  properties: KlaviyoProfileProperties
): void {
  const klaviyo = getKlaviyo();
  if (!klaviyo) return;

  klaviyo.identify(properties).catch((error) => {
    logToSentry("Klaviyo identify failed", {
      extras: [["error", String(error)]],
    });
  });
}

export function trackKlaviyoEvent(
  event: string,
  properties?: Record<string, unknown>
): void {
  const klaviyo = getKlaviyo();
  if (!klaviyo) return;

  klaviyo.track(event, properties).catch((error) => {
    logToSentry("Klaviyo track event failed", {
      extras: [
        ["event", event],
        ["error", String(error)],
      ],
    });
  });
}

/**
 * Clears the Klaviyo identity cookie (__kla_id) to disassociate the
 * browser from the current profile. Klaviyo has no built-in reset/logout
 * method, so clearing this cookie is the recommended approach.
 */
export function resetKlaviyo(): void {
  deleteCookie("__kla_id");
}
